import { Link } from "react-router-dom";
import { useState } from "react";

type INavbarVariants = "white" | "black";
interface INavbarProps {
  variant?: INavbarVariants;
}

const Navbar = ({ variant = "white" }: INavbarProps) => {
  const [isNavVisible, setIsNavVisible] = useState(false);
  const toggleNav = () => {
    setIsNavVisible(!isNavVisible);
  };
  const isWhiteText = variant === "white" ? "text-black" : "text-white";
  return (
    <div className="container mx-auto">
      <header
        className={`py-6 flex items-center justify-between  ${isWhiteText} `}
      >
        <div className="">
          <Link to="/">
            {variant === "white" ? (
              <span className="font-caveat text-2xl md:text-6xl text-[#000]">
                Hunger<span className="text-RubberDuckyYellow">C</span>lean
              </span>
            ) : (
              <span className="font-caveat text-2xl md:text-6xl text-[#000]">
                <span className="text-[#48ff00]">S</span>aveHunger
              </span>
            )}
          </Link>
        </div>
        <div className="hidden lg:flex items-center space-x-8 font-medium">
          <Link to="/">
            <p className="text-xl md:text-3xl">Personal</p>
          </Link>
          <Link to="/business">
            <p className="text-xl md:text-3xl">Business</p>
          </Link>
          <button
            className={`border border-black ${
              variant === "white" ? "" : "border-red-500"
            }  rounded-lg py-2.5 px-2 active:scale-90 transition duration-150 `}
          >
            <Link to="">
              <div className=" flex flex-col space-y-2 justify-center items-center cursor-pointer w-fit transition-all duration-500">
                <span className="w-8 h-[2px] bg-black"></span>
                <span className="w-8 h-[2px] bg-black"></span>
                <span className="w-8 h-[2px] bg-black"></span>
              </div>
            </Link>
          </button>
        </div>

        <div
          className="lg:hidden flex items-center space-x-8 font-medium"
          onClick={toggleNav}
        >
          {isNavVisible ? (
            "--"
          ) : (
            <button
              className={`border border-black ${
                variant === "white" ? "" : "border-red-500"
              }  rounded-lg py-2.5 px-2 active:scale-90 transition duration-150 `}
            >
              <Link to="">
                <div className=" flex flex-col space-y-2 justify-center items-center cursor-pointer w-fit transition-all duration-500">
                  <span className="w-8 h-[2px] bg-black"></span>
                  <span className="w-8 h-[2px] bg-black"></span>
                  <span className="w-8 h-[2px] bg-black"></span>
                </div>
              </Link>
            </button>
          )}
        </div>
      </header>
      {/* {isNavVisible && (
        <div className="fixed  bg-gray-600 opacity-95  z-10 w-11/12  ">
          <div
            className={`flex flex-col space-y-4 items-center mt-4 lg:hidden ${
              variant === "white" ? "text-white" : "text-black"
            }`}
          >
            <Link to="/">
              <p>Personal</p>
            </Link>
            <Link to="/business">
              <p>Business</p>
            </Link>
            <button
              className={`border ${
                variant === "white" ? "" : "border-yellow-400"
              }  rounded-lg py-2.5 px-[18px] active:scale-90 transition duration-150 `}
            >
              <Link to="">
                <div className=" flex flex-col space-y-2 justify-center items-center cursor-pointer w-fit transition-all duration-500">
                  <span className="w-8 h-[2px] bg-white"></span>
                  <span className="w-8 h-[2px] bg-white"></span>
                  <span className="w-8 h-[2px] bg-white"></span>
                </div>
              </Link>
            </button>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default Navbar;
